import { Component } from '@angular/core';
import { LogService } from '../../services/log.service';
import { RouterService } from '../../services/router.service';
import { SessionService } from '../../services/session.service';

@Component({
  selector: 'app-logout',
  template: `
    <div class="card col-12 mt-3 mb-3">
      <div class="card-block">

        <h1 class="card-title">Log Out Confirmation</h1>

        <div class="col-10 alert alert-warning">
          You are about to Log Out. Are you sure?
        </div>

        <div class="row button-container mb-3">
          <div class="col-2">
            <button class="btn btn-primary" (click)="submit()">Proceed to Logout</button>
          </div>
          <div class="col-2">
            <button class="btn" (click)="cancel()">Cancel</button>
          </div>
        </div>

      </div>
    </div>
  `
})
export class LogoutConfirmComponent {
  constructor(
    private log: LogService,
    private router: RouterService,
    private session: SessionService
  ) {}

  submit() {
    this.log.trace('logout');
    this.session.terminate();
  }

  cancel() {
    this.router.gotoHome();
  }
}
